import { de, enGB, fr } from 'date-fns/locale';

export type Language = 'en' | 'de' | 'fr';

export const SUPPORTED_LANGUAGES: Language[] = ['en', 'de', 'fr'];

export const DEFAULT_LANGUAGE = 'en';

export const DATE_FNS_LOCALE_MAP = {
	en: enGB,
	de: de,
	fr: fr,
} as const;
